import React from "react";
import {
  ProjectDetailsContainer,
  ProjectDetailsContent,
  DetailItem,
  DetailLabel,
  DetailValue,
  ProjectDetailsTitle,
} from "./styles";

export interface ProjectDetail {
  label: string;
  value: string;
}

export interface ProjectDetailsProps {
  details: ProjectDetail[];
  title?: string;
}

export const ProjectDetails: React.FC<ProjectDetailsProps> = ({
  details,
  title = "Project Details",
}) => {
  return (
    <ProjectDetailsContainer>
      <section className="py-5">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-12">
              <ProjectDetailsTitle>{title}</ProjectDetailsTitle>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-8">
              <ProjectDetailsContent>
                {details.map((detail, index) => (
                  <DetailItem key={index}>
                    <DetailLabel>{detail.label}</DetailLabel>
                    <DetailValue>{detail.value}</DetailValue>
                  </DetailItem>
                ))}
              </ProjectDetailsContent>
            </div>
          </div>
        </div>
      </section>
    </ProjectDetailsContainer>
  );
};

export default ProjectDetails;
